import SuggestedAddIngredientModal from './SuggestedAddIngredientModal'

export default SuggestedAddIngredientModal
